<template>
  <AdsButton
    v-bind="$attrs"
    :loading="$store.state.isLoading"
    color="warning"
    button-text="Unpublish"
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'UnpublishButton',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
